import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createHead } from '@unhead/vue/client'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { useAuthenticationStore } from '@/stores/authentication.js';

// i18n
import { createI18n } from 'vue-i18n';
import { en as usaEnglish } from '@/i18n/usa_english';
import App from './App.vue'
import router from './router'

import "leaflet/dist/leaflet.css";
import '@/assets/styles/main.scss';

// Mount App
const mountApp = async (locale) => {
  const app = createApp(App);

  if(!import.meta.env.PROD) {
    app.config.devtools = true;
  }

  const pinia = createPinia();
  pinia.use(piniaPluginPersistedstate)

  const authenticationStore = useAuthenticationStore(pinia);
  await authenticationStore.loadUserData();

  const i18n = createI18n({
    legacy: false,
    locale: locale,
    fallbackLocale: 'en',
    messages: {
      en: usaEnglish,
    },
  });

  const head = createHead()

  app
    .use(pinia)
    .use(i18n)
    .use(head)
    .use(router);

  app.mount('#app');
};


mountApp('en');
